import React from 'react';

interface Component_Props {
    first_label: string,
    second_label: string,
    third_label: string,
    first_value: string,
    second_value: string,
    third_value: string,
    font_size: string
}

function Component(props: Component_Props) {
    const style0: React.CSSProperties | undefined = { width: "100%", margin: "0 auto", height: "90%", minHeight: "210px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between" };
    const style1: React.CSSProperties | undefined = { width: "100%", height: "30%", background: "unset", display: "flex", flexDirection: "column", alignItems: "center" };
    const style2: React.CSSProperties | undefined = { width: "100%", height: "30%", background: "unset", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", fontWeight: "bold", color: "#9A9DAF" };
    const style3: React.CSSProperties | undefined = { width: "100%", height: "70%", background: "unset", display: "flex", alignItems: "center", justifyContent: "center", fontSize: props.font_size, fontWeight: "bold", textAlign: "center", color: "#"};

    return (
        <div style={style0}>
            <div style={style1}>
                <div style={style2}>{props.first_label}</div>
                <div style={{ width: "100%", height: "70%", borderBottom:"1px solid #D9D9D9", background: "#ffe3e3", display: "flex", alignItems: "center", justifyContent: "center", fontSize: props.font_size, fontWeight: "bold", textAlign: "center", color: "#"}}>{props.first_value}</div>
            </div>
            <div style={style1}>
                <div style={style2}>{props.second_label}</div>
                <div style={{ width: "100%", height: "70%", borderBottom:"1px solid #D9D9D9", background: "#fff0d0", display: "flex", alignItems: "center", justifyContent: "center", fontSize: props.font_size, fontWeight: "bold", textAlign: "center", color: "#"}}>{props.second_value}</div>
            </div>
            <div style={style1}>
                <div style={style2}>{props.third_label}</div>
                <div style={{ width: "100%", height: "70%", borderBottom:"1px solid #D9D9D9", background: "#f4fffd", display: "flex", alignItems: "center", justifyContent: "center", fontSize: props.font_size, fontWeight: "bold", textAlign: "center", color: "#"}}>{props.third_value}</div>
            </div>
        </div>
    )
}



export default Component;

